// Consume one secret from the URL fragment and remove it before rendering.
// Fragments never reach HTTP access logs or Referer headers; replaceState keeps
// them out of browser history and screenshots after the SPA has adopted them.

export function consumeAuthFragment(name: 'verify' | 'reset'): string | null {
  try {
    const hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
    const value = hashParams.get(name);
    if (!value) return null;
    hashParams.delete(name);
    const hash = hashParams.toString();
    try {
      history.replaceState(
        null,
        '',
        location.pathname + location.search + (hash ? `#${hash}` : ''),
      );
    } catch {
      // The in-memory value still completes the flow when history is blocked.
    }
    return value;
  } catch {
    return null;
  }
}
